var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"cc-calendar-day",class:{
    'cc-calendar-day--not-current': !_vm.day.isCurrentMonth,
    'cc-calendar-day--today': _vm.isToday,
    'cc-calendar-day--range': _vm.inRange,
    'cc-calendar-day--arrival': _vm.isArrival,
    'cc-calendar-day--departure': _vm.isDeparture,
    'cc-calendar-day--arrival-day': _vm.isArrivalDay,
    'cc-calendar-day--departure-day': _vm.isDepartureDay,
    'cc-calendar-day--disabled': _vm.isDisabled,
  },on:{"click":function($event){return _vm.selectDate(_vm.day)}}},[_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }